import { render, staticRenderFns } from "./EducationalQualificationEdit.vue?vue&type=template&id=7e12f988"
import script from "./EducationalQualificationEdit.vue?vue&type=script&lang=ts"
export * from "./EducationalQualificationEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports